import { Box, CarFront, ChevronRight, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CTASection, PageHero, PrototypeNotice, SectionIntro, ServiceCard } from '../components/Sections';
import { services } from '../data';

export function Services() {
  return (
    <>
      <PageHero
        eyebrow="Sawwari services"
        title="A focused service for movement across Pakistan."
        text="Travel within a city, ride city to city, send an eligible local parcel or build your earning path through one consistent account experience."
        tone="violet"
      >
        <div className="button-row">
          <Link className="button button--light" to="/services/rides">Explore rides</Link>
          <Link className="button button--ghost-light" to="/services/courier">Explore courier</Link>
        </div>
      </PageHero>

      <section className="section">
        <div className="container">
          <SectionIntro
            eyebrow="Launch portfolio"
            title="City travel, intercity travel and local delivery."
            text="Coverage is configured by city, route, category and operating readiness; courier remains within-city unless expressly enabled otherwise."
          />
          <div className="service-grid">
            {services.map((service) => <ServiceCard service={service} key={service.title} />)}
          </div>
          <PrototypeNotice>
            Availability, category coverage, pricing and operating hours are controlled through the active service configuration and may differ by area.
          </PrototypeNotice>
        </div>
      </section>

      <section className="section section--soft">
        <div className="container service-journey-grid">
          <article className="service-journey">
            <span className="service-journey__icon tone-violet"><CarFront /></span>
            <div><span className="eyebrow">Passenger journey</span><h2>Choose. Request. Travel.</h2></div>
            <ol>
              <li><span>1</span><p><strong>Set the journey</strong> Add pickup and destination.</p></li>
              <li><span>2</span><p><strong>Choose a category</strong> Select the ride option you requested.</p></li>
              <li><span>3</span><p><strong>Review and confirm</strong> Check key journey information before proceeding.</p></li>
            </ol>
            <Link className="text-link" to="/services/rides">View ride service <ChevronRight size={17} /></Link>
          </article>
          <article className="service-journey">
            <span className="service-journey__icon tone-coral"><Box /></span>
            <div><span className="eyebrow">Courier journey</span><h2>Prepare. Request. Deliver.</h2></div>
            <ol>
              <li><span>1</span><p><strong>Confirm eligibility</strong> Review prohibited and restricted items.</p></li>
              <li><span>2</span><p><strong>Add both parties</strong> Enter sender and recipient details.</p></li>
              <li><span>3</span><p><strong>Seal and hand over</strong> The Captain may inspect and refuse unsafe items.</p></li>
            </ol>
            <Link className="text-link" to="/services/courier">View courier service <ChevronRight size={17} /></Link>
          </article>
        </div>
      </section>

      <section className="section compact-trust">
        <div className="container compact-trust__inner">
          <ShieldCheck />
          <div><span className="eyebrow">One trust standard</span><h2>Account, journey and support records stay connected.</h2></div>
          <Link className="button button--secondary" to="/safety">Safety centre</Link>
        </div>
      </section>

      <CTASection
        title="See where you fit into the Sawwari journey."
        text="Explore passenger services or preview the Captain registration experience."
        primary={{ label: 'Explore rides', to: '/services/rides' }}
        secondary={{ label: 'Captain journey', to: '/captains' }}
      />
    </>
  );
}
